<template>
  <div class="bht-function-list">
    <!-- <div
      class="cell"
      v-for="(item, index) in 20"
      :key="index"
      @click="show(item)"
    >
      <div class="left">
        <span class="title">边互通更新{{ item }}</span>
        <span class="time">0月22日</span>
      </div>
      <div class="arrow">
        <img class="icon" src="@/assets/icon/ic_arrow_right.png" />
      </div>
    </div> -->
    <div class="ignore test"></div>
    <a
      style="margin-top: 20px"
      href="itms-apps://apps.apple.com/cn/app/%E8%BE%B9%E4%BA%92%E9%80%9A/id1500549596"
      >ok</a
    >
  </div>
</template>

<script>
// @ is an alias to /src
//import HelloWorld from "@/components/HelloWorld.vue";

export default {
  name: "Home",
  components: {
    //HelloWorld
  },
  data() {
    return {};
  },
  created() {
    var ua = navigator.userAgent.toLowerCase();
    var isWeixin = ua.indexOf("micromessenger") != -1;
    var isAndroid = ua.indexOf("android") != -1;
    var isIos = ua.indexOf("iphone") != -1 || ua.indexOf("ipad") != -1;
    console.log("isWeixin==>" + isWeixin);
    console.log("isAndroid==>" + isAndroid);
    console.log("isIos==>" + isIos);
  },
  methods: {
    show(item) {
      console.log(item);
      this.$router.push("/show");
      // this.$plusExtends(() => {
      //   var cmr = window.plus.camera.getCamera();
      //   cmr.captureImage(path => {
      //     alert(path);
      //   });
      // });
    }
  }
};
</script>
<style lang="scss">
.bht-function-list {
  padding: 0 20px;
}
.test {
  width: 100px;
  height: 100px;
  background-color: red;
}
.cell {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 108px;

  &::after {
    content: "";
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    height: 1px;
    background-color: #eeeeee;
  }
  .left {
    span {
      display: block;
      text-align: left;
    }
    .title {
      font-size: 30px;
      color: #2c2c2b;
    }
    .time {
      font-size: 24px;
      color: #9b9a9a;
    }
  }
  .arrow {
    .icon {
      width: 16.11px;
      height: 29.22px;
    }
  }
}
</style>
